import { render, staticRenderFns } from "./DocumentStatusBar.vue?vue&type=template&id=6c7cd160&scoped=true"
import script from "./DocumentStatusBar.vue?vue&type=script&lang=js"
export * from "./DocumentStatusBar.vue?vue&type=script&lang=js"
import style0 from "./DocumentStatusBar.vue?vue&type=style&index=0&id=6c7cd160&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7cd160",
  null
  
)

export default component.exports